import {
  requestLogin,
  requestTransfer,
} from '@/api/otherSite';

const state = {
  resultLogin: null,
  resultTransfer: null,
};

const getters = {
  resultLogin: (state) => state.resultLogin,
  resultTransfer: (state) => state.resultTransfer,
};

const actions = {
  async login({ commit, dispatch, rootGetters }, { postParams }) {
    await dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const result = await requestLogin({ csrfToken, postParams });
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    commit('resultLogin', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },
  async transferPoint({ commit, dispatch, rootGetters }, { postParams }) {
    await dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const result = await requestTransfer({ csrfToken, postParams });
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    commit('resultTransfer', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },
};

const mutations = {
  resultLogin(state, data) {
    state.resultLogin = data;
  },
  resultTransfer(state, data) {
    state.resultTransfer = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
